module.exports = __webpack_public_path__ + "images/noPaymentImage.cc6aafd6.svg";